/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  GetService,
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
// import { ImageURL } from "../../../../Environment/Environment";
import defaultImg from "../../../../assets/img/thumbnail.png";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import Pagination from "../../../../Helper/Pagination";
import { MoonLoader } from "react-spinners";
import { Switch } from "@mui/material";

export default function FramesListing() {
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [error, setError] = useState(false);

  const [frameslist, setframeslist] = useState();

  const [Title, setTitle] = useState("");
  const [Price, setPrice] = useState("");
  const [state, setstate] = useState("");
  const [Image, setImage] = useState("");
  const [ImgPath, setLocalImgPath] = useState("");
  const [selectedState, setselectedState] = useState("");

  useEffect(() => {
    getframesList();
  }, [search_key, currentPage]);

  const getframesList = () => {
    setLoading(true);
    GetService(`${API_URL.FRAMES_LISTING}?status=All&search_key=${search_key}`).then(
      (res) => {
        console.log(res?.data);
        if (res.data.status === true) {
          setframeslist(res?.data?.data);
          // SetTotalPageCount(res.data.totalPages);
          // SetTotalCount(res.data.totalItems);
          // setCount(res.data.currentPage * param.limit);
          setLoading(false);
        } else {
          showErrorAlert(res.data?.message);
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  const changeStatus = async (id, status) => {
    const data = {
      id: id,
      status: status === "Active" ? "Inactive" :"Active",
    };

    PostService(API_URL.UPDATE_FRAMES_LISTING, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(`Status ${status === "Active" ? "inactive" : "active"} successfully`, getframesList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const onimageUpload = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setLocalImgPath(window.URL.createObjectURL(e.target.files[0]));
    }
  };

  useEffect(() => {
    console.log(selectedState);
    setTitle(selectedState?.name);
    setPrice(selectedState?.price);
    setLocalImgPath(selectedState?.image);
    setImage(selectedState?.image);
  }, [selectedState]);

  const submit = (e) => {
    e.preventDefault();
    if (!Title || !Price || !Image) {
      setError(true);
      return;
    }

    setsubmitLoader(true);
    const formdata = new FormData();
    if (state === "Edit") {
      formdata.append("id", selectedState?.cansplfr_id);
    }
    formdata.append("name", Title);
    formdata.append("price", Price);
    formdata.append("image", Image);

    const url =
      state === "Add"
        ? API_URL.ADD_FRAMES_LISTING
        : API_URL.UPDATE_FRAMES_LISTING;

    PostFormData(url, formdata).then(
      (res) => {
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getframesList);
          resetFunc();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  function Delete(id, name) {
    const data = {
      id: id,
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.DELETE_FRAME, data).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, getframesList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  function resetFunc() {
    setselectedState("");
    setTitle("");
    setPrice("");
    setImage("");
    setLocalImgPath(defaultImg);
    setError(false);
    setsubmitLoader(false);
  }

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Frames List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Frames List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div className="align-items-center d-flex justify-content-between row">
                    {/* <div className="col-md-4 p-0">
                      <div className="offset-md-1">
                        <button
                          className="btn btn-primary"
                          data-toggle="modal"
                          data-target="#EditModal"
                          onClick={() => {
                            setstate("Add");
                            resetFunc();
                          }}
                        >
                          Add Frames
                        </button>
                      </div>
                    </div> */}
                    {/* <div className="col-md-4 p-0 offset-8">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Title"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div> */}
                  </div>
                  <div class="table-responsive mt-4">
                    {!loading && (
                      <table class="table table-hover table-bordered table-striped">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Image</th>
                            <th className="text-center">Title</th>
                            <th className="text-center">Price ($)</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {frameslist?.map((item, i) => (
                            <tr key={i}>
                              <td className="text-center">{i + 1}</td>
                              <td className="text-center">
                                <img
                                  src={item?.image}
                                  alt="..."
                                  onError={(e) => {
                                    e.target.src = defaultImg;
                                  }}
                                />
                              </td>
                              <td className="text-center">{item?.name}</td>
                              <td className="text-center"> {item?.price}</td>
                              <td className="text-center">
                                <label
                                  className={
                                    item?.status === "Active"
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                  }
                                >
                                  {item?.status === "Active"
                                    ? "Active"
                                    : "Inactive"}
                                </label>
                              </td>
                              <td className="text-center">
                                <span className="toggle-switch">
                                  <Switch
                                    checked={item?.status === "Active"}
                                    onChange={() => {
                                      changeStatus(
                                        item.cansplfr_id,
                                        item.status
                                      );
                                    }}
                                    size="small"
                                    color="primary" // You can customize the color
                                    inputProps={{
                                      "aria-label": "toggle switch",
                                    }}
                                  />
                                </span>
                                <span
                                  title="Edit"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setstate("Edit");
                                    setselectedState(item);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>

                                {/* <span
                                  title="Delete"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  onClick={() => {
                                    Delete(item?.cansplfr_id, "Frame");
                                  }}
                                >
                                  <i className="text-danger fas fa-trash"></i>{" "}
                                </span> */}
                              </td>
                            </tr>
                          ))}
                          {frameslist && frameslist.length === 0 && (
                            <tr>
                              <td colSpan="5" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    {/* <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------EDIT MODAL START---------- */}

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h4 className="modal-title" id="exampleModalLabel">
                {state} Frames
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Title</label>
                  <input
                    type="text"
                    name="title"
                    value={Title}
                    className="form-control"
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Title"
                  />
                  {error && !Title && (
                    <div className="error mt-1">Title is required</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Price</label>
                  <input
                    type="number"
                    min={0}
                    name="price"
                    value={Price}
                    className="form-control"
                    onChange={(e) => setPrice(e.target.value)}
                    placeholder="Price"
                  />
                  {error && !Price && (
                    <div className="error mt-1">Price is required</div>
                  )}
                </div>
                <div className="mt-3">
                  <div className="row d-flex align-items-start">
                    <div className="col-md-5 col-6">
                      <span>
                        <span className="btn btn-primary col-12">
                          Select Image
                          <input
                            type="file"
                            name="image"
                            accept=".jpg,.jpeg,.png"
                            className="btn-input position-absolute"
                            style={{ opacity: 0 }}
                            onChange={(e) => onimageUpload(e)}
                          />
                        </span>
                      </span>

                      {error && !Image && (
                        <div className="error mt-1">Image is required</div>
                      )}
                    </div>
                    <div className="col-md-7 col-6">
                      <img
                        src={ImgPath}
                        alt="..."
                        className="CommonImage"
                        onError={(e) => {
                          e.target.src = defaultImg;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                {/* <button type="submit" className="btn btn-primary">
                 {state==='Add'?'Add':'Update' }
                </button> */}

                <button
                  type="submit"
                  className="btn btn-primary py-2"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : state === "Add" ? (
                    "Add"
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
